<template>
  <v-dialog v-model="fullscreen.dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">                
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="fullscreen.dialog = false" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Notifications</v-toolbar-title>
        <v-spacer></v-spacer>
        <!--<v-toolbar-items>
          <v-btn dark flat @click.native="dialog = false">Save</v-btn>
        </v-toolbar-items>-->
      </v-toolbar>
      <v-list two-line class="pa-0">                    
        <v-list-tile avatar v-for="item in notifs" :key="item.title" @click="handleClick(item)">
          <v-list-tile-avatar>
            <v-icon :class="[item.color] +' white--text'">{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ format(item.time) }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon ripple>
              <v-icon color="grey lighten-1">info</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        
      </v-list>
    </v-card>
  </v-dialog>
</template>


<script>
import Notif  from '@/util/models/Notif';     
import moment from 'moment';

const notif = new Notif();
    
export default {
  name: 'widget-dialog-notif',    
  data () {
    return {        
        basic: {
            dialog: false
        },
        fullscreen: {
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false        
        },
        scrollable: {
            name: '',
            dialog: false        
        },  
        items: [],
        notifs: [
            { icon: 'folder', iconClass: 'green lighten-1 white--text', title: 'Data', subtitle: 'Jan 9, 2014' },            
        ],
        folders: [
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014' },
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014' },
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014' }
        ],
        files: [
            { icon: 'assignment', iconClass: 'blue white--text', title: 'Vacation itinerary', subtitle: 'Jan 20, 2014' },
            { icon: 'call_to_action', iconClass: 'amber white--text', title: 'Kitchen remodel', subtitle: 'Jan 10, 2014' }
        ]
    };
  },
  
  created () {    
    var context = this;
        
    context.$store.watch(
        function (state) {
            return state;
        },
        function () {
            context.init(); 
        },
        {deep: true}
    );  
      
    window.getApp.$on('APP_OPEN_DIALOG_NOTIF', () => {
        //this.getNotif();
        this.fullscreen.dialog = true;
      
    });  
  },
  
  mounted() {
     this.init();   
  },
  
  computed: {
      
  },  
  
  methods: {
    init(){
        notif.all().then(data => {
            this.notifs = data;
        });
    },  
      
    openfull(){
        this.fullscreen.dialog = true;
    },
    
    getNotif(){        
        //window.getApp.$store.dispatch('entities/notifications/insert', {data : this.data});
        var notifs = window.getApp.$store.getters['entities/notifications/query']().orderBy('id', 'desc').limit(4).get();
        this.items = notifs;
    },
    
    handleClick(item) {
        if(item.ref.path){
            this.fullscreen.dialog = false;
            this.$router.push({path:'/accounting/acc-periode', query:{flag:true}});
        }        
    },
    
    format(time){
        return moment(time).format('ddd, DD MMMM YYYY, HH:mm:ss');
    }
    
  }
};
</script>
